import { Button } from '@/components/form/baseInputs/Button';
import { Download01Icon } from '@/components/icons/Download01Icon';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useTrackUserEvent } from '@/hooks/useTrackUserEvent';
import { $downloadStreamedFile } from '@/modules/files/utils/fileUtils';

import { useDownloadGiftExportV2Mutation } from './graphql/DownloadGiftingCSVButton.generated';

export interface DownloadGiftingCSVButtonProps {
  householdId: string;
  disabled?: boolean;
}

export function DownloadGiftingCSVButton({
  householdId,
  disabled = false,
}: DownloadGiftingCSVButtonProps) {
  const { showFeedback } = useFeedback();
  const trackUserEvent = useTrackUserEvent();
  const { createErrorFeedback } = useFeedback();

  const [generateCSV] = useDownloadGiftExportV2Mutation({
    variables: {
      householdId,
    },
    onError: createErrorFeedback('Failed to download CSV export'),
    onCompleted: async (data) => {
      const token = data.exportLifetimeExclusionEventsV2.token;
      try {
        await $downloadStreamedFile(`/api/download/file?token=${token}`);
        trackUserEvent('gift_list exported', {
          householdId,
        });
      } catch (err) {
        showFeedback('Failed to download CSV. Please try again.');
      }
    },
  });

  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={() => generateCSV()}
      startIcon={Download01Icon}
      disabled={disabled}
    >
      Export CSV
    </Button>
  );
}
